<template>
  <div>
    <div class="container mini">
      <div class="bg-gray rounded-md shadow my-6">
        <div class="flex justify-between items-start">
          <div class="p-6 md:px-9 md:pt-9 pb-6">
            <Logo class="w-48 md:w-auto" />
          </div>
          <LangSwitcher />
        </div>
        <div class="pb-9 px-6 md:px-9 border-b border-purple-gray">
          <p class="leading-snug" />
        </div>
        <div class="pb-5 px-6 md:px-9">
          <h2 class="font-semibold text-black-display mt-6 mb-3 text-2xl text-center ornament">
            {{ $t('auth.forgotPasswordHeader') }}
          </h2>
          <div
            v-if="sent"
            class="py-12 text-center mx-auto text-green font-semibold"
          >
            {{ $t('auth.forgotPasswordMessage') }}
          </div>
          <form
            v-else
            class="pt-6 mb-4"
            @submit.prevent="submit"
          >
            <div
              class="mb-4"
              :class="{'input-error': (errors.email || errors.server) && !loading}"
            >
              <label
                class="block text-black-display text-base font-semibold mb-1"
                for="email"
              >
                {{ $t('auth.email') }}
              </label>
              <input
                id="email"
                v-model="email"
                class="appearance-none border border-gray-500 rounded z-10 relative text-xl w-full py-3 px-3 text-black-display mb-2 leading-tight focus:outline-none"
                type="email"
                required
              >
              <transition name="slide-up">
                <p
                  v-if="errors.email && !loading"
                  key="EmailErr"
                  class="text-error z-1"
                >
                  {{ $t('auth.error.email') }}
                </p>
                <p
                  v-if="errors.server && !loading"
                  key="ServerErr"
                  class="text-error z-1"
                >
                  {{ $t('auth.error.server') }}
                </p>
              </transition>
            </div>
            <div class="flex items-center justify-center mb-9">
              <button
                :class="{'loading': loading}"
                class="btn h-14 px-9 flex items-center"
                type="submit"
              >
                {{ $t('auth.send') }}
                <transition name="zoom-in">
                  <div
                    v-if="loading"
                    class="spinner w-5 h-5 ml-3 -mr-3 animate-spin"
                  >
                    <SpinnerIcon />
                  </div>
                </transition>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import LangSwitcher from '@/components/LangSwitcher';
import Logo from '@/assets/img/logo.svg';
import SpinnerIcon from '@/assets/icons/spinner.svg';
import { HTTP_NOT_FOUND, INTERNAL_SERVER_ERROR } from '@/utils/axios/codes';

export default {
  name: 'ForgotPassword',
  components: {
    LangSwitcher,
    Logo,
    SpinnerIcon,
  },
  data() {
    return {
      email: '',
      loading: false,
      blocked: false,
      sent: false,
      errors: {
        email: false,
        server: false,
      },
    };
  },
  watch: {
    email() {
      this.errors.email = false;
    },
  },
  methods: {
    ...mapActions('auth', ['forgotPassword']),
    async submit() {
      if (!this.blocked) {
        this.blockRequestsFor(700);
        this.sent = false;

        try {
          await this.forgotPassword({
            email: this.email,
          });
          this.sent = true;
        } catch (e) {
          if (e.response?.status === HTTP_NOT_FOUND) {
            this.errors.email = true;

            return;
          }
          if (e.response?.status === INTERNAL_SERVER_ERROR) {
            this.errors.server = true;

            return;
          }
          console.error(e);
          throw new Error(e);
        } finally {
          this.loading = false;
        }
      }
    },
    blockRequestsFor(blockDuration) {
      this.blocked = true;
      this.loading = true;
      setTimeout(() => {
        this.blocked = false;
      }, blockDuration);
    },
  },
};
</script>
<style lang="scss" scoped>
  .spinner {
    position: absolute;
    right: 36px;
    top: 18px;
  }
  input {
    transition: all .5s ease;
  }
  button {
    position: relative;
    transition: all .5s ease;
    padding-right: 36px;
    &.loading {
      padding-right: 58px;
    }
  }
</style>
